
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/change-password",
      function () {
        return require("private-next-pages/profile/change-password/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/change-password"])
      });
    }
  